import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Header } from './Header';
import { TabNav } from './TabNav';
import { BottomNav } from './BottomNav';
import { CommandPalette } from './CommandPalette';
import { ScrollToTop } from './ScrollToTop';
import { KeyboardShortcutsHelp } from './KeyboardShortcutsHelp';
import { useMembers } from '@/hooks/useMembers';
import { useUIStore } from '@/stores/uiStore';

export function PageShell() {
  const { data: members } = useMembers();
  const setCommandOpen = useUIStore((s) => s.setCommandOpen);
  const [shortcutsOpen, setShortcutsOpen] = useState(false);
  const memberCount = members?.length ?? 0;
  const countryCount = members
    ? new Set(members.map((m) => m['Home Country']).filter(Boolean)).size
    : 0;
  const companyCount = members
    ? new Set(members.map((m) => m.Company).filter(Boolean)).size
    : 0;

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setCommandOpen(true);
      }
      if (e.key === '?' && !e.metaKey && !e.ctrlKey && !(e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement)) {
        e.preventDefault();
        setShortcutsOpen(true);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [setCommandOpen]);

  return (
    <div className="min-h-screen bg-background">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:top-4 focus:left-4 focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground">Skip to main content</a>
      <Header
        memberCount={memberCount}
        countryCount={countryCount}
        companyCount={companyCount}
      />
      <TabNav />
      <main id="main-content" className="p-4 md:p-6 pb-24 md:pb-6">
        <Outlet />
      </main>
      <BottomNav />
      <CommandPalette />
      <ScrollToTop />
      <KeyboardShortcutsHelp open={shortcutsOpen} onOpenChange={setShortcutsOpen} />
      <Toaster position="top-center" richColors />
    </div>
  );
}
